import { Image, Page, StyleSheet, View } from "@react-pdf/renderer";
import React from "react";
import {
    calculateImageDimensions,
    ConvertedImage,
    convertPdfToImages,
    getFooter,
} from "../../../utils/helperUtils";

const styles = StyleSheet.create({
    page: {
        padding: "30px 40px",
        backgroundColor: "#ffffff",
        position: "relative",
    },
    mainContainer: {
        flex: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        paddingBottom: 50,
    },
    imageContainer: {
        border: "1px solid #e0e0e0",
        borderRadius: 4,
        backgroundColor: "#f8f9fa",
        padding: 10,
        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
});

const ImagePage: React.FC<{
    image: ConvertedImage;
    confidentialInfo: string;
    pageIndex: number;
}> = ({ image, confidentialInfo, pageIndex }) => {
    const dimensions = calculateImageDimensions(image.width, image.height);

    return (
        <Page key={`page-${pageIndex}`} size="A4" style={styles.page}>
            <View style={styles.mainContainer}>
                <View style={styles.imageContainer}>
                    <Image
                        src={image.url}
                        style={{
                            width: dimensions.width,
                            height: dimensions.height,
                        }}
                    />
                </View>
            </View>

            {getFooter(confidentialInfo)}
        </Page>
    );
};

export const PropertyMailPage = async (
    confidentialInfo: string,
    downloadLinks: string[]
): Promise<JSX.Element[]> => {
    try {
        const allPagesPromises = downloadLinks.map(async link => {
            const convertedImages = await convertPdfToImages(link);

            return convertedImages.map((image, index) => (
                <ImagePage
                    key={`${link}-${index}`}
                    image={image}
                    confidentialInfo={confidentialInfo}
                    pageIndex={index}
                />
            ));
        });

        const allPages = await Promise.all(allPagesPromises);

        return allPages.flat();
    } catch (error) {
        console.error("Error generating property mail pages:", error);

        return [];
    }
};
